import classNames from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { TYPES, ICON_COMPONENT_MAP } from './constants';

export { TYPES };

const Icon = ({
  flipHorizontally,
  flipVertically,
  type,
  width,
  height,
  className,
  ...otherProps
}) => {
  const IconComponent = get(ICON_COMPONENT_MAP, type);

  return (
    <div
      {...otherProps}
      className={classNames('Icon', `Icon--${type}`, className, {
        'Icon--flipped-horizontally': flipHorizontally,
        'Icon--flipped-vertically': flipVertically,
      })}
    >
      {IconComponent && <IconComponent width={width} height={height} />}
      <style jsx>
        {`
          .Icon--flipped-horizontally {
            transform: scale(-1, 1);
          }

          .Icon--flipped-vertically {
            transform: scale(1, -1);
          }

          .Icon--flipped-horizontally.Icon--flipped-vertically {
            transform: scale(-1, -1);
          }
        `}
      </style>
      <style jsx global>
        {`
          .Icon svg,
          .Icon img {
            display: block;
          }
        `}
      </style>
    </div>
  );
};

Icon.propTypes = {
  type: PropTypes.oneOf(Object.values(TYPES)),
  flipHorizontally: PropTypes.bool,
  flipVertically: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

Icon.defaultProps = {
  type: null,
  flipHorizontally: false,
  flipVertically: false,
  width: undefined,
  height: undefined,
  className: null,
};

export default Icon;
